import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { TargetGroupFilter } from './target-group-filter.interface';
import { TargetGroupFilterService } from './target-group-filter.service';

const service = new TargetGroupFilterService();

export interface TargetGroupFilterState {}

const targetGroupFilterStore: Module<TargetGroupFilterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getTargetGroupFilters(context, query?: LocationQuery) {
         const response = await service.getTargetGroupFilters(query);
         return response;
      },
      async postTargetGroupFilter(context, targetGroupFilter: TargetGroupFilter) {
         const response = await service.postTargetGroupFilter(targetGroupFilter);
         return response;
      },
      async putTargetGroupFilter(context, targetGroupFilter: TargetGroupFilter) {
         const response = await service.putTargetGroupFilter(targetGroupFilter);
         return response;
      },
      async deleteTargetGroupFilter(context, targetGroupFilterId: number) {
         const response = await service.deleteTargetGroupFilter(targetGroupFilterId);
         return response;
      },
   },
};

export default targetGroupFilterStore;
